import { render } from "./tableParamTable.vue?vue&type=template&id=4bd4413e"
import script from "./tableParamTable.vue?vue&type=script&lang=js"
export * from "./tableParamTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__